import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Shield, Lock, Mail, ArrowRight } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext.js';
import { EduButton } from '../components/EduButton.js';

export const Login: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      await login(email, password);
      navigate('/dashboard');
    } catch (err: any) {
      setError(err.message || 'Falha na autenticação administrativa.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-surface-secondary flex flex-col justify-center items-center p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="flex items-center justify-center gap-2 mb-2">
            <img
              src="/logo-edurender.png"
              alt="EduRender"
              className="h-12 object-contain"
            />
            <span className="text-xs font-bold bg-brand-graphite text-white px-2 py-0.5 rounded tracking-widest">
              MASTER
            </span>
          </div>
          <p className="text-xs font-semibold text-brand-primary tracking-wide uppercase">
            Portal de Administração e Controle SaaS
          </p>
        </div>

        <div className="bg-surface border border-bdr rounded-xl shadow-sm p-8">
          <div className="mb-6 flex items-center justify-between">
            <div>
              <h2 className="text-lg font-bold text-txt-primary">Acesso Administrativo</h2>
              <p className="text-xs text-txt-secondary mt-0.5">
                Restrito a gestores e operadores autorizados.
              </p>
            </div>
            <div className="w-10 h-10 rounded-full bg-slate-100 flex items-center justify-center text-brand-graphite">
              <Shield size={20} />
            </div>
          </div>

          {error && (
            <div className="mb-4 p-3 bg-red-50 border border-red-200 text-status-error text-xs rounded-lg">
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-xs font-semibold text-txt-primary mb-1.5">
                E-mail de Administrador
              </label>
              <div className="relative">
                <Mail className="absolute left-3 top-2.5 text-txt-muted" size={16} />
                <input
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="admin@edurender.com.br"
                  className="w-full pl-9 pr-3 py-2 text-sm bg-surface border border-bdr rounded-md text-txt-primary placeholder:text-txt-muted focus:outline-none focus:border-brand-primary focus:ring-1 focus:ring-brand-primary"
                />
              </div>
            </div>

            <div>
              <label className="block text-xs font-semibold text-txt-primary mb-1.5">
                Chave de Acesso
              </label>
              <div className="relative">
                <Lock className="absolute left-3 top-2.5 text-txt-muted" size={16} />
                <input
                  type="password"
                  required
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="••••••••••••"
                  className="w-full pl-9 pr-3 py-2 text-sm bg-surface border border-bdr rounded-md text-txt-primary placeholder:text-txt-muted focus:outline-none focus:border-brand-primary focus:ring-1 focus:ring-brand-primary"
                />
              </div>
            </div>

            <EduButton
              type="submit"
              variant="primary"
              size="lg"
              className="w-full mt-2"
              isLoading={loading}
              icon={<ArrowRight size={16} />}
            >
              Autenticar como Master
            </EduButton>
          </form>
        </div>

        <p className="text-center text-xs text-txt-muted mt-6">
          Todas as ações administrativas são registradas em logs de auditoria imutáveis.
        </p>
      </div>
    </div>
  );
};
